// src/services/discountService.js
import axiosClient from "./axiosClient";

const route = "schoolDiscount";

// Get all discounts
export const getAllDiscounts = async (params) => {
  try {
    const response = await axiosClient.get(`${route}/getAll`, {
      params,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Create a new discount
export const createDiscount = async (discountData) => {
  try {
    const response = await axiosClient.post(`${route}`, {
      name: discountData.name,
      // type: discountData.type,
      // amount: discountData.amount,
      // percentage: discountData.percentage,
      amount:
        discountData.type == "percentage"
          ? discountData.percentage
          : discountData.amount,
      isPercentage: discountData.type === "percentage",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Update an existing discount
export const updateDiscount = async (discountId, updateData) => {
  try {
    // const payload = {
    //   name: updateData.name,
    //   type: updateData.type,
    //   amount: updateData.amount,
    //   percentage: updateData.percentage,
    // };
    const response = await axiosClient.put(
      `${route}/${discountId}`,
      updateData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete a discount
export const deleteDiscount = async (discountId) => {
  try {
    const response = await axiosClient.delete(`${route}/${discountId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get a specific discount by ID
export const getDiscountById = async (discountId) => {
  try {
    const response = await axiosClient.get(`${route}/${discountId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
